<template>
  <div id="app" class = "container-fluid">
      <div v-show="currentComponent == 'Start'" class="align-self-center" id="start-div">
        <div class="pull-left top-bar" style="white-space: nowrap;">
          <a href ="https://www.headcount.org/" target="_blank">
            <img id = "madlibs_logo_landingpg" src="./assets/HeadCountLogoEmily.png" height="65vh" style="margin-left: 1rem; margin-top: .5rem;">
          </a>
          <span id="ss_icons_landing" style='float:right'>
            <a href="https://fb.me/HeadCountOrg" target="_blank"><i class="fab fa-facebook-f ss_icon"></i></a>
            <a href="https://twitter.com/headcountorg" target="_blank"><i class="fab fa-twitter ss_icon"></i></a>
            <a href="https://instagram.com/headcountorg" target="_blank"><i class="fab fa-instagram ss_icon"></i></a>
          </span>
        </div>
        <div class="col-xl-5 center">
          <img src="./assets/MadLibs_logo_no_Phil.png" class="center" id="ml-logo">
        </div>
        <div class="text-center title-padded">
          <h5 class="title-text-small kauf">Your way to</h5>
        </div>
        <div id="underlined-election-day-title" class="center text-center col-xs-12 col-sm-5 col-lg-6 col-xl-4">
          <h2 class="title-text-large handwritten">Election Day</h2>
        </div>
        <div class="text-center opaque animated bounce delay-2s"><p class="text-xs">NOUN</p></div>
        <div class="text-center" id ="start-button-div">
          <button class="start-button nob" id = "startButtonID" @click="swapComponent('1');"> <h4 id="writeYourStory">Write Your Story</h4></button>
        </div>
      </div>

      <div id ="endscreencontainer">
      <div id = "questions" v-show="currentComponent >= 1">
        <div class="pull-left">
          <a href ="https://www.headcount.org/" target="_blank">
            <img id="hcLogoWhite" src="./assets/HeadCountLogoEmily.png" height="65vh" style="margin-left: 1rem; margin-top: .5rem">
          </a>
          <span id="ss_icons_landing" style='float:right'>
            <a href="https://fb.me/HeadCountOrg" target="_blank"><i class="fab fa-facebook-f ss_icon"></i></a>
            <a href="https://twitter.com/headcountorg" target="_blank"><i class="fab fa-twitter ss_icon"></i></a>
            <a href="https://instagram.com/headcountorg" target="_blank"><i class="fab fa-instagram ss_icon"></i></a>
          </span>
        </div>
        <div class="center" id="questions-view-title-div">
          <h4 id="questions-view-title-text" class="nob" style="text-align: center;">{{storyTitle}}</h4>
        </div>
        <div class="center" id="question-main-wrapper">
          <div id="progress-bar-wrapper">
            <div id="progress-bar-div">
              <p class="tk-classic-comic" id="progress-bar-text" style="text-align: right;">
                {{ progressPercent }}% Completed
              </p>
            </div>
            <div id="progress-bar">
                <b-progress height=".6rem" variant="danger" :value="progressPercent"></b-progress>
            </div>
          </div>

          <div v-show="currentComponent == '1'">
            <div style="" class="question-form">
              <div class="center" style='display: inline-block'>
                <h3 class="nob" style = "color: #002ca9;" id="votingMethodTitle">HOW ARE YOU VOTING?</h3>
                </div>
                <br />
                  <button class="start-button votingMethSelectionButton" id = "nextButton" @click="generateQuestions('person'); swapComponent('2'); endStoryCalc(); " > <input type="radio" name="person" value="In Person" ><span class="nob votingMethodSelectionText" style = "color: #002ca9;"> In Person </span></button>
                  <button class="start-button votingMethSelectionButton" id = "nextButton2" @click="generateQuestions('mail'); swapComponent('2'); endStoryCalc(); " > <input type="radio" name="mail" value="By Mail" ><span class="nob votingMethodSelectionText" style = "color: #002ca9;"> By Mail </span></button>
                  <button class="start-button votingMethSelectionButton" id = "nextButton3" @click="generateQuestions('early'); swapComponent('2'); endStoryCalc(); " ><input type="radio" name="early" value="Early" ><span class="nob votingMethodSelectionText" style = "color: #002ca9;"> Early </span></button>
            </div>
          </div>

          <div id="question-card-main-wrapper" v-for="question in questions" v-show="!(currentComponent == '1') && currentComponent != (questions.length)  && loading == false && download == false && imdone == false && shareME == false">
            <div id="question-form" v-show="currentComponent == question.questionID"  style="position: fixed;" class="col-xl-4 center question-form">
              <input autofocus type="text" class="center tk-classic-comic" id="customForm" ref="input" @focus="renderpp = false" @blur="renderpp = true"v-model="customResponse" @keyup.enter="setQuestion(question); submitCustomResponse(question.questionID)"/>
              <div class="center">
                <p id="question-text" v-html="question.questionText" style="text-align: center; text-transform: uppercase; color: #002ca9;"></p>
                <p class="optIn" v-if="question.questionText == 'YOUR EMAIL'" style="text-align: center;"><input type="checkbox" checked> Send me emails from HeadCount (subject to our <u><a class="ppclass" href="https://www.headcount.org/privacy-policy/" target="_blank">privacy policy</a></u>)</p>
                <p class="optIn" v-if="question.questionText == 'YOUR PHONE NUMBER'" style="text-align: center;"><input type="checkbox" checked> Send me text messages from HeadCount</p>
              </div>
            </div>
            <div v-show="parseInt(currentComponent) > 1 && currentComponent != questions.length">
                <b-button id="backButton" v-show="currentComponent == question.questionID" @click="setQuestion(question); submitCustomResponse(question.questionID)" class="bg-alert center col-xl-1 col-lg-2 col-md-1 col-xs-1 bg-alert nob">Next</b-button>
            </div>
          </div>
          <div id="question-card" style="position:relative" v-show="!(currentComponent == questions.length ) || currentComponent == 1">
            <img id="cardsIMG" src="./assets/card-stack.png" srcset="./assets/card-stack@2x.png 2x, ./assets/card-stack@3x.png 3x" class="center" >
          </div>
        </div>

        <br />
        <br />
        <div >
        </div>
      </div>

      <div id = "end" v-show="currentComponent == (questions.length) && currentComponent != 1 && loading == false && download == false && imdone == false && shareME == false">
        <div id = "end-text" class="col-sm-6 col-md-11 col-lg-9 col-xl-6 center">
          <span v-for="(story, index) in endStory">
            <span v-if="!(index%2==0)" class="highlightme handwritten">{{story}}</span>
            <span v-html="story" v-else>{{story}}</span>
          </span>
          <br />
          <div id="storyENDbuttons"style="align-content center; margin-bottom: 30vh;">
            <button class="start-button fixedButton savebut" id = "" @click="loading2(); downloadME(); calcIMG(); imageMe(true)" > <h5 class="buttonTXT nob">Save as Image</h5></button>
            <button class="start-button fixedButton savebut" id = "fbShareButton" @click="loading2(); shareMEAnim(); FBShare();" > <h5 id="fbsharetxt" class="buttonTXT nob">Share on Facebook</h5></button>
            <button class="start-button fixedButton savebut" @click="loading2(); shareMEAnim(); calcIMG(); TWShare()"> <h5 class="buttonTXT nob">Share on Twitter</h5></button>
            <button class="start-button fixedButton savebut" id="imDONE" @click="imdoneSwitch();"> <h5 id="imdonetxt" class="buttonTXT nob">I'm Done</h5></button>
            </div>
          </div>
          </div>

          <div id="loading" v-show="loading" style="">
            <h1 id = "lding" style="color: white;">Loading...</h1>
            <div class="loader"></div>
          </div>

          <div id="download" v-show="download" style="">
            <a v-bind:href="downloadLinkEx" target="_blank"><h1 id="downME" style="color: white;">Click to Download Image</h1></a>
          </div>

          <div id="shareME" v-show="shareME" style="">
            <a v-bind:href="shareLink" target="_blank"><h1 id="downME" style="color: white;">Click to Share Your Story</h1></a>
          </div>

          <div id="imdone" v-show="imdone" style="">
            <div style="">
              <a v-bind:href="excludeStory"><button class="start-button fixedButton savebut nob endbtn"> <h5 class="buttonTXT endBTNText">Make a New Story</h5></button></a><br />
              <a href="https://www.headcount.org/verify-voter-registration/" target="_blank"><button  class="start-button fixedButton savebut nob endbtn"> <h5 id="vvreg" class="buttonTXT endBTNText">Verify Voter Registration</h5></button></a><br />
              <a href="https://www.headcount.org/your-ballot/" target="_blank"><button class="start-button fixedButton savebut nob endbtn"> <h5 class="buttonTXT endBTNText">What's On My Ballot</h5></button></a>
            </div>
          </div>

</div>
<footer align="center" v-if="(renderpp || windowWidth > 500) && !storydisplayed">
  <p class='privacy-policy2'>From HEAD COUNT MAD LIBS ®. © Head Count Inc</p>
<p class='privacy-policy2'>Mad Libs format © 2018 by Penguin Random House LLC. All rights reserved.</p>
</footer>
</div>
</template>

<script>
import { uuid } from 'vue-uuid'
import axios from 'axios'
import VueAxios from 'vue-axios'
import html2canvas from 'html2canvas';
import canvas2image from 'canvas2image';
import vueHeadful from 'vue-headful';
import questionFlow from './questionFlow.js'
export default {
  name: 'app',
  data: function() {
         return  {
           customResponse: '',
           currentComponent: "Start",
           startButton: "Write your story",
           nextButtonMessage: "Next",
           answers: [],
           userID: "",
           questions: [],
           endStory: [],
           flowSelection: "",
           storyTitle: "",
           thisQ: "",
           showDismissibleAlert: true,
           nextNotClicked: true,
           displayScript: "",
           s3Link: "",
           username: "",
           s3IMGlink: "",
           loading: false,
           downloadLinkEx: "",
           download: false,
           shareME: false,
           imdone: false,
           moreHTML: '<br>Write Your Own Story At: ',
           shareLink: '',
           renderpp: true,
           windowWidth: 0
         }
  },
  beforeMount(){
    console.log('asset version: 2')
    this.windowWidth = document.documentElement.clientWidth;
    console.log(this.windowWidth)
  },
  methods: {
    swapComponent: function(component)
    {
      if(component == 1){
        document.body.style.backgroundPosition = "0rem 0rem";
        let ts = Date.now().toString()
        this.submitData(ts, 'timestamp')
      }

      this.currentComponent = component
      this.$nextTick(() => this.$refs.input[component].focus())
    },
    calcShareSnip(){
      let ex = questionFlow[this.flowSelection].export
      if(this.flowSelection == 'inPerson1'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "..."
      }
      if(this.flowSelection == 'inPerson2'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "..."
      }
      if(this.flowSelection == 'inPerson3'){
        ex[0] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[2] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[4] = "..."
      }
      if(this.flowSelection == 'mail1'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "..."
      }
      if(this.flowSelection == 'mail2'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
      }
      if(this.flowSelection == 'early1'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "..."
      }
      if(this.flowSelection == 'early2'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "..."
      }
      this.displayScript = ex.join(' ')
    },
    calcShareSnip2(){
      let ex = questionFlow[this.flowSelection].export2
      if(this.flowSelection == 'inPerson1'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[9] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[11] = "..."
      }
      if(this.flowSelection == 'inPerson2'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[9] = "..."
      }
      if(this.flowSelection == 'inPerson3'){
        ex[0] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[2] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[4] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[6] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[8] = "<span class='highlightme'>" + this.endStory[9] + "</span>"
        ex[10] = "..."
      }
      if(this.flowSelection == 'mail1'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[9] = "..."
      }
      if(this.flowSelection == 'mail2'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "..."
      }
      if(this.flowSelection == 'early1'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[9] = "..."
      }
      if(this.flowSelection == 'early2'){
        ex[1] = "<span class='highlightme'>" + this.endStory[1] + "</span>"
        ex[3] = "<span class='highlightme'>" + this.endStory[3] + "</span>"
        ex[5] = "<span class='highlightme'>" + this.endStory[5] + "</span>"
        ex[7] = "<span class='highlightme'>" + this.endStory[7] + "</span>"
        ex[9] = "..."
      }
      this.displayScript = ex.join(' ')
    },
    calcIMG(){
      let pushME = []
      for(let i = 0; i < this.endStory.length + 1; i++){
        if(i%2!=0 && this.endStory[i]){
          pushME.push('<span class="highlightme handwritten">' + this.endStory[i] + '</span>')
        }
        else{
          pushME.push(this.endStory[i])
        }
      }
      this.displayScript = pushME.join(' ')
    },
    nextClicked(){
      this.nextNotClicked = false
    },
    submitCustomResponse: function(questionID)
    {
      if(!(this.thisQ == 'YOUR FIRST NAME' || this.thisQ == 'YOUR LAST NAME' || this.thisQ == 'YOUR EMAIL' || this.thisQ == 'YOUR PHONE NUMBER' || this.thisQ == 'YOUR ZIP CODE') ){
        this.answers.push(this.customResponse.toUpperCase())
        this.endStory[(questionID * 2)-3] = this.customResponse.toUpperCase()
      }
      if(this.thisQ == 'YOUR FIRST NAME'){
        this.username = this.customResponse.toUpperCase()
      }
      this.submitData(this.customResponse.toUpperCase(), questionID)
      this.swapComponent( questionID + 1 )
      this.customResponse = ""
      this.$nextTick(() => this.$refs.input[questionID].focus())
      if(questionID == this.questions.length -1){
        this.$nextTick(() => this.$refs.input[questionID].blur())
      }
    },
    generateUserID: function(){
      this.userID = this.$uuid.v4()
    },
    submitData: function(data, questionID){
        axios.post('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/newEvent', {
          userID: this.userID,
          answer: data,
          questionID: questionID
        })
        .then(function (response) {})
    },
    imageMe: function(up){
      let imgLink = 'https://s3.amazonaws.com/madlibs.headcount.org/userImages/img' + this.userID + '.png'
      this.s3IMGlink = imgLink
      this.calcShareSnip2()
      let cry =   ' '
            let social = true
            let notSocial = false
      let x = questionFlow[this.flowSelection].title
      let st = this.displayScript
      let idfuck = this.userID
      let nameME = this.username
      let htmlw = this.moreHTML
      let snipME = 'snip'
      let none = 'none'
      let incStorySize = '#storymainid{font-size: 2rem;}'
      this.submitData('YES', 'IMGDownload')
        axios.post('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/uploadHTML',
          {userID: idfuck, story: st, title: x, name: nameME, s3IMGLink: imgLink, moreHTML: htmlw, addSnip: none, addSnip2: snipME, social: notSocial, cry: cry, incStorySize: incStorySize}
        )
      let link = "https://s3.amazonaws.com/madlibs.headcount.org/userLinks/MyVotingDayStory_" + this.userID + ".html"
      setTimeout(function(){
        axios.get('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/proxyf?hor=no&id=' + this.userID + '&url=' + link)
      }, 2000);
      this.downloadLinkEx = imgLink
      // setTimeout(function(){ window.open(imgLink,"_target") }, 5000);
    },
    FBShare: function(){
      let cry =   '<div style="width: 100%"><span class="gar"><h1 id="giant" style="text-align: center;"> <a style="color:white;" href="https://madlibs.headcount.org">Write Your Own!</a></h1></span></div><br>'
            let social = true
            let notSocial = false
      this.calcShareSnip()
      this.submitData('YES', 'FBSHARE')
      axios.post('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/uploadHTML',
        {userID: this.userID, story: this.displayScript, title: questionFlow[this.flowSelection].title, name: this.username, s3IMGLink: ' ', moreHTML: this.moreHTML, addSnip: 'snip', addSnip2: 'snip', social: social, cry:cry, incStorySize: ' '}
      )
      let link = "http://madlibs.headcount.org/userLinks/MyVotingDayStory_" + this.userID + 'snip' + ".html"
      setTimeout(function(){
        axios.get('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/proxyf?id=' + this.userID +'snip'+ '&url=' + link + "&hor=yes")
      }, 2000);
      let x = questionFlow[this.flowSelection].title
      let imgLink = 'http://madlibs.headcount.org/userImages/img' + this.userID + '.png'
      let htmlLink = 'http://madlibs.headcount.org/userLinks/MyVotingDayStory_' + this.userID + '.html'
      this.calcShareSnip2()
      let st = this.displayScript
      let idfuck = this.userID
      let nameME = this.username
      let htmlw = this.moreHTML
      let snipME = 'snip'
      let none = 'none'
      setTimeout(function(){
        axios.post('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/uploadHTML',
          {userID: idfuck, story: st, title: x, name: nameME, s3IMGLink: imgLink, moreHTML: htmlw, addSnip: none, addSnip2: snipME, social: notSocial, cry: cry, incStorySize: ' '}
        )
      }, 3000);
      this.shareLink = "https://www.facebook.com/sharer/sharer.php?u=" + htmlLink + "&amp;src=sdkpreparse"
    },
    TWShare: function(){
      this.submitData('YES', 'TWShare')
      let cry =   '<div style="width: 100%"><span class="gar"><h1 id="giant" style="text-align: center;"> <a style="color:white;" href="https://madlibs.headcount.org">Write Your Own!</a></h1></span></div><br>'
      let imgLink = 'https://s3.amazonaws.com/madlibs.headcount.org/userImages/img' + this.userID + '.png'
      this.s3IMGlink = imgLink
      axios.post('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/uploadHTML',
        {userID: this.userID, story: this.displayScript, title: questionFlow[this.flowSelection].title, name: this.username, s3IMGLink: ' ', moreHTML: this.moreHTML, addSnip: 'none', addSnip2: 'none', social: false, cry: cry, incStorySize: ' '}
      )
      let link = "https://madlibs.headcount.org/userLinks/MyVotingDayStory_" + this.userID + ".html"
      setTimeout(function(){
        axios.get('https://fnipagsgg0.execute-api.us-east-1.amazonaws.com/dev/proxyf?id=' + this.userID + '&url=' + link + "&hor=yes")
      }, 2000);
      let htmlLink = link
        this.shareLink = "https://twitter.com/intent/tweet?text=Mad Libs Your Way to Election Day @headcountorg %23electionmadlibs %23thefutureisvoting " + htmlLink
    },
    generateQuestions: function(flow){
      let random = Math.floor(Math.random() * 10);
      if((random < 3 && flow == "person")){
        this.flowSelection = "inPerson1"
      }
      else if((random > 6 && flow == "person")){
        this.flowSelection = "inPerson2"
      }
      else if((random < 5 && flow == "mail") || this.exclude == "mail2"){
        this.flowSelection = "mail1"
      }
      else if((random > 5 && flow == "mail") || this.exclude == "mail1"){
        this.flowSelection = "mail2"
      }
      else if((random < 5 && flow == "early") || this.exclude == "early2"){
        this.flowSelection = "early1"
      }
      else if((random > 5 && flow == "early") || this.exclude == "early1"){
        this.flowSelection = "early2"
      }
      else {
        this.flowSelection = "inPerson3"
      }
      this.storyTitle = questionFlow[this.flowSelection].title
      let mark = 0
      questionFlow[this.flowSelection].questions.forEach(q => {
        this.questions.push({})
      })
      questionFlow[this.flowSelection].questions.forEach(q => {
        this.questions[mark].questionText = q
        this.questions[mark].questionID = mark
        mark++
      })
    },
    endStoryCalc: function (){
      this.endStory = questionFlow[this.flowSelection].endStory
    },
    pollingPlace: function(resp){
      if(resp == "yes") {
        this.pollingPlace = true;
      }
      else {
        this.pollingPlace = false;
      }
    },
    setQuestion(q){
      this.thisQ = q.questionText;
    },
    loading2(){
      this.loading = true
      setTimeout(() => { this.loading = false;  }, 8000)
    },
    downloadME(){
      setTimeout(() => { this.download = true }, 8000)
      setTimeout(() => { this.download = false }, 15000)
    },
    shareMEAnim(){
      setTimeout(() => { this.shareME = true }, 8000)
      setTimeout(() => { this.shareME = false }, 15000)
    },
    imdoneSwitch(){
      this.imdone = true
    }
  },
  computed: {
    progressPercent: function(){
      if (this.currentComponent == 1){
        return 0
      }
      var perc = Math.floor((this.currentComponent / (this.questions.length)) * 100)
      return perc
    },
    storydisplayed: function(){
      if(this.currentComponent == this.questions.length){
        return true
      }
      else{
        return false
      }
    },
    excludeStory(){
      return "https://madlibs.headcount.org?ex=" + this.flowSelection
    },
    exclude(){
      let myParam = 'inPerson1'
      return myParam
    }
  },
  mounted: function(){
    this.generateUserID()
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue